import { render } from "./mygoodorderTuiDesc.vue?vue&type=template&id=85803090&scoped=true"
import script from "./mygoodorderTuiDesc.vue?vue&type=script&lang=js"
export * from "./mygoodorderTuiDesc.vue?vue&type=script&lang=js"

import "./mygoodorderTuiDesc.vue?vue&type=style&index=0&id=85803090&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85803090"]])

export default __exports__